/** @jsxImportSource @emotion/react */
import * as _ from "lodash";
import moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { TextInput } from "../../components/forms/inputs/TextInput";
import { css } from "@emotion/react";
import { SelectInput } from "../../components/forms/inputs/SelectInput";

interface OwnProps {
  onSearch: Function;
  onReset: Function;
  isFromDateVisible: boolean;
  isToDateVisible: boolean;
  isEmailVisible: boolean;
  isEventNameVisible: boolean;
}

type FormValues = {
  fromDate: string;
  toDate: string;
  email: string;
  eventName: string;
};

const wrapperStyle = css`
  gap: 16px;
`;

const events = _.uniq([
  "",
  "hd_user_signed_up",
  "hd_drink_claimed",
  "hd_product_purchased",
  "hd_user_subscription_subscribed",
  "hd_user_subscription_deleted",
  "hd_user_subscription_canceled",
  "user_subscription_plan_changed",
  "user_approval_accepted",
  "user_approval_denied",
  "hd_charge_succeeded",
  "hd_charge_refunded",
  "hd_invoice_created",
  "hd_invoice_payed",
  "hd_invoice_payment_failed",
  "hd_invoice_payment_attempt_failed",
  "member_card_added",
  "member_card_deleted",
  "member_card_deleted_api",
  "member_card_deleted_webhook",
  "member_card_activated",
  "user_employee_id_changed",
  "user_employee_id_reset",
  "user_role_updated_by_admin",
  "user_term_accepted",
  "mailer_email_send",
  "cashback_received",
  "venue_payment_authorized",
]);

const eventOptions = events.map((x) => ({ label: x, value: x }));

export const MonitorEventListFiltersForm = (props: OwnProps) => {
  const isAnyFilterVisible = props.isFromDateVisible || props.isToDateVisible;
  const methods = useForm<FormValues>({
    defaultValues: {
      fromDate: "",
      toDate: "",
      email: "",
      eventName: "",
    },
  });

  const handleSubmit = (values: FormValues) => {
    props.onSearch({
      ...values,
      fromDate: values.fromDate ? moment(values.fromDate).format() : undefined,
      toDate: values.toDate ? moment(values.toDate).format() : undefined,
      eventName:
        values.eventName && values.eventName !== ""
          ? values.eventName
          : undefined,
      email: values.email && values.email !== "" ? values.email : undefined,
    });
  };

  if (!isAnyFilterVisible) {
    return null;
  }

  return (
    /* @ts-ignore */
    <FormProvider {...methods}>
      <form className="card">
        <div className="card-header">
          <h3 className="card-title">Filters</h3>
        </div>
        <div className="card-body">
          <div css={wrapperStyle} className="row">
            {props.isFromDateVisible && (
              <TextInput
                name="fromDate"
                label="From Date"
                type="date"
                placeholder="Choose from date"
              />
            )}
            {props.isToDateVisible && (
              <TextInput
                name="toDate"
                label="To Date"
                type="date"
                placeholder="Choose to date"
              />
            )}
            {props.isEmailVisible && (
              <TextInput name="email" label="Email" placeholder="Enter email" />
            )}
            {props.isEventNameVisible && (
              <SelectInput
                name="eventName"
                label="Event Name"
                options={eventOptions}
              />
            )}
          </div>
        </div>
        <div className="card-footer text-right">
          <div className="d-flex">
            <input
              className="btn btn-link"
              type="reset"
              value="Reset"
              onClick={(e) => {
                methods.reset();
                props.onReset(e);
              }}
            />
            <button
              type="button"
              className="btn btn-sm btn-primary ml-auto"
              onClick={methods.handleSubmit(handleSubmit)}
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default MonitorEventListFiltersForm;
